import $ from 'jquery'
import { initSlides } from '../abstracts/utils'

export default function() {
  $(() => {
    if (!$('body').hasClass('page-template-news')) return

    let $sectionPosts = $('.section-posts')
    initSlides($sectionPosts.find('.first-row.mobile .latest-posts.slideshow:not(.slick-initialized.slick-slider)'), 1, true, false, [], null, false)

    $('.load-more-cta a').on('click', function(e) {
      let btn = $(e.target)
      let currentPage = parseInt(btn.attr('current-page'))
      let nextPage = currentPage + 1

      $.get(window.endpoint + '/get-posts', {
        /* eslint-disable */
        posts_per_page: localVar['posts_per_page'],
        page: nextPage,
      })
        .done(res => {
          // console.log(res)
          let data = JSON.parse(res)
          // console.log(data)
          let index = $sectionPosts.find('.second-row .column-left .latest-posts .post-item')
          if (data.posts && data.posts.length) {
            for (let i = 0; i < data.posts.length; i++) {
              $sectionPosts.find('.second-row .column-left .latest-posts').append(generatePostHTML(data.posts[i], index))
              index++
            }
          }
          if (nextPage < data.max_num_pages) {
            btn.attr('current-page', nextPage)
          } else {
            btn.hide()
          }
        })
        .fail(err => {
          console.log(err)
        })

    })
  })
}

function generatePostHTML(post, index) {
  let html = ""

  html += `<div class="post-item" post-id="${post.ID}" post-index="${index}"><div class="post-item__inner">`
  html += `<div class="post__thumbnail" style="background-image: url('${post.thumbnail}')"></div>`
  html += `<div class="post__content"><p class="fs-14 text-cap cl--lochmara">tin mới</p>`
  html += `<h3 class="post__title"><a href="${post.url}">${post.post_title}</a></h3>`
  html += `<div class="post__excerpt">${post.excerpt}</div>`
  html += `<div class="post__author mt-5">`
  html += `<div class="author__avatar"><img src="${post.post_author.avatar}" /></div>`
  html += `<div class="author__name"><p>${post.post_author.name} - ${post.date}</p></div>`
  html += `</div>`
  html += `</div>`
  html += `</div></div>`

  return html
}


